import React, { Component } from "react";
import { hot } from "react-hot-loader";
import DeleteIcon from "@material-ui/icons/Delete";
import {
    Paper,
    Typography,
    Select,
    MenuItem,
    Button,
    FormControl,
    InputLabel,
    Grid,
    Card,
    Table,
    TableBody,
    TableRow,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import {
    getReports,
    getReportKeys,
    getReportTypes,
    setMonth,
    setToMonth,
    setYear,
    setReportType,
    getJobPackReports,
    getExcelDoc,
    setNewDownload,
    getDownloads,
    deleteDownload,
    getVehicleAlertReport,
} from "./actions";
import moment from "moment";
import Alert from '@material-ui/lab/Alert';
var filteredReports = "";
let months = {
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    jun: "June",
    jul: "July",
    aug: "August",
    sep: "September",
    oct: "October",
    nov: "November",
    dec: "December",
};
let monthValues =  {
    jan: 1,
    feb: 2,
    mar: 3,
    apr: 4,
    may: 5,
    jun: 6,
    jul: 7,
    aug: 8,
    sep: 9,
    oct: 10,
    nov: 11,
    dec: 12,
}
const range = (start, stop, step) =>
    Array.from(
        { length: (stop - start) / step + 1 },
        (_, i) => start + i * step
    );
class BuildExcelDoc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            doc_report_type: "",
            doc_year: moment().format("YYYY"),
            doc_month: moment().subtract(1,'months').format("MMM").toLowerCase(),
            doc_to_month: moment().format("MMM").toLowerCase(),
            doc_id: "",
        };
        props.setMonth(moment().subtract(1,'months').format("MMM").toLowerCase());
        props.setToMonth(moment().format("MMM").toLowerCase());
        props.setYear(moment().format("YYYY"));
        props.getReports();
        props.getReportKeys();
        props.getReportTypes();
        props.getJobPackReports();
        props.getDownloads();
        props.getVehicleAlertReport();
    }
    getReportName(reportType) {
        this.props.reportTypes &&
            Object.entries(this.props.reportTypes).map((f) => {
                if (f.includes(reportType)) {
                    return (filteredReports = f[1]);
                }
                return null;
            });
    }
    render() {
        const downloads =
            this.props.downloads === [] ? false : this.props.downloads;
        const {
            month,
            toMonth,
            year,
            reportType,
            setMonth,
            setToMonth,
            setYear,
            reportTypes,
            selectedReports,
            sm,
            md,
            lg,
        } = this.props;
        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <Paper
                    style={{
                        borderRadius: 0,
                        textAlign: "center",
                        position: "relative",
                        // overflow: "hidden",
                        height: "100%",
                    }}
                >
                    <Typography
                        variant="h6"
                        style={{
                            padding: "10px",
                            backgroundColor: "#0288CC",
                            color: "white",
                        }}
                    >
                        Download Reports As Excel
                    </Typography>
                    <FormControl
                        style={{
                            margin: 12,
                            padding: 12,
                            borderRadius: 6,
                            background: "#eee",
                            width: "95%",
                        }}
                    >
                        <InputLabel>Please Select Month From</InputLabel>
                        <Select
                            value={
                                month === false
                                    ? moment().subtract(1,'months').format("MMM").toLowerCase()
                                    : month
                            }
                            onChange={(event) => {
                                this.setState({
                                    doc_month: event.target.value,
                                });
                                setMonth(event.target.value);
                            }}
                        >
                            <MenuItem value={"all_months"}>Months</MenuItem>
                            {reportTypes &&
                                Object.keys(months).map((e) => {
                                    return (
                                        <MenuItem value={e} key={e}>
                                            {months[e]}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                    <FormControl
                        style={{
                            margin: 12,
                            padding: 12,
                            borderRadius: 6,
                            background: "#eee",
                            width: "95%",
                        }}
                    >
                        <InputLabel>Please Select Month To</InputLabel>
                        <Select
                            value={
                                toMonth === false 
                                    ? moment().format("MMM").toLowerCase()
                                    : toMonth
                            }
                            onChange={(event) => {
                                monthValues[event.target.value] <= monthValues[month] ?
                                this.setState({ open : false}) : 
                                this.setState({
                                    doc_to_month: event.target.value,
                                    open : false
                                });
                                setToMonth(event.target.value);
                            }}
                        >
                            <MenuItem value={"all_months"}>Months</MenuItem>
                            {reportTypes &&
                                Object.keys(months).map((e) => {
                                    return (
                                        <MenuItem value={e} key={e}>
                                            {months[e]}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                    { this.state.open ? 
                    <Alert style={{
                        width: "95%",
                        padding: 12,
                        borderRadius: 6,
                        marginLeft: 24,
                    }} severity="error">From Date should be greater than To Date</Alert> : 
                    <></>
                    }
                    <FormControl
                        style={{
                            width: "95%",
                            padding: 12,
                            borderRadius: 6,
                            margin: 12,
                            background: "#eee",
                        }}
                    >
                        <InputLabel>Please Select Year</InputLabel>
                        <Select
                            value={
                                year ? Number(year) : moment().format("YYYY")
                            }
                            onChange={(event) => {
                                this.setState({ doc_year: event.target.value });
                                setYear(event.target.value);
                            }}
                        >
                            <MenuItem value={"all_years"}>Years</MenuItem>
                            {reportTypes &&
                                range(2018, moment().format("YYYY"), 1).map(
                                    (e) => {
                                        return (
                                            <MenuItem value={e} key={e}>
                                                {e}
                                            </MenuItem>
                                        );
                                    }
                                )}
                        </Select>
                    </FormControl>
                   
                    {/*<Button
                        style={{
                            width: "95%",
                            marginLeft: 12,
                            backgroundColor: "#0288CC",
                        }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.setState({
                                doc_month: moment().format("MMM").toLowerCase(),
                                doc_year: moment().format("YYYY"),
                            });
                            setMonth(moment().format("MMM").toLowerCase());
                            setToMonth(moment().format("MMM").toLowerCase());
                            setYear(moment().format("YYYY"));
                        }}
                    >
                        {"Select Current Date"}
                    </Button>*/}
                    {reportTypes && (
                        <FormControl
                            style={{
                                width: "95%",
                                padding: 12,
                                borderRadius: 6,

                                margin: 12,
                                background: "#eee",
                            }}
                        >
                            <InputLabel>Please Select Report Type</InputLabel>
                            <Select
                                value={
                                    reportType === false
                                        ? "all_categories"
                                        : reportType
                                }
                                onChange={(event) => {
                                    this.setState({
                                        doc_report_type: event.target.value,
                                    });
                                    this.getReportName(event.target.value);
                                    this.props.setReportType(
                                        event.target.value
                                    );
                                }}
                            >
                                <MenuItem value={"all_categories"}>
                                    All Categories
                                </MenuItem>
                                <MenuItem value={"vehicle_alerts"}>
                                    Vehicle Alerts
                                </MenuItem>
                                {reportTypes &&
                                    Object.keys(reportTypes).map((e) => {
                                        // if (e !== "custom_report")
                                        return (
                                            <MenuItem value={e} key={e}>
                                                {reportTypes[e]}
                                            </MenuItem>
                                        );
                                        // else return null;
                                    })}
                            </Select>
                        </FormControl>
                    )}
                    <Button
                        disabled={selectedReports === false || this.state.open }
                        style={{
                            width: "95%",
                            marginLeft: 12,
                            backgroundColor: "#0288CC",
                            color: "white",
                        }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.props.setNewDownload(
                                this.state.doc_year,
                                this.state.doc_month,
                                filteredReports,
                                this.state.doc_id
                            );
                            this.props.getExcelDoc(
                                selectedReports,
                                reportType,
                                this.props.reportKeys[reportType]
                            );
                        }}
                    >
                        {selectedReports && reportType
                            ? "Download"
                            : !selectedReports && !reportType
                            ? "No Report Selected"
                            : "No Reports Available"}
                    </Button>
                    <hr style={{ height: "2px", backgroundColor: "#0288CC" }} />

                    <Card>
                        <Typography
                            variant="h5"
                            style={{
                                textAlign: "center",
                                color: "white",
                                backgroundColor: "#0288CC",
                            }}
                        >
                            Downloads History
                        </Typography>
                    </Card>
                    <div>
                        <Table>
                            <TableBody>
                                {downloads &&
                                    downloads.map((e, i) => {
                                        return (
                                            <TableRow key={i}>
                                                <div
                                                    className="icon-text-container"
                                                    style={{
                                                        borderWidth: "medium",
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "9px",
                                                        marginTop: "22px",
                                                        marginLeft: "10px",
                                                        marginRight: "10px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <div
                                                        className="float-left text-container"
                                                        style={{
                                                            display: "flex",
                                                            marginTop:"18px"                                                  
                                                        }}
                                                    >
                                                        <span>
                                                            <h5
                                                                style={{
                                                                    border:
                                                                        "2px solid #0188cc",
                                                                    marginLeft:
                                                                        "10px",
                                                                    borderRadius:
                                                                        "12px",
                                                                    padding:
                                                                        "7px",
                                                                    textAlign:
                                                                        "center",
                                                                    width:
                                                                        "480px",
                                                                    
                                                                }}
                                                            >
                                                                <b>
                                                                    Report Type:
                                                                </b>{" "}
                                                                <span className="subHeading">
                                                                    {e.doc_report_type.replace(
                                                                        "_",
                                                                        " "
                                                                    )}
                                                                </span>
                                                            </h5>
                                                        </span>
                                                        <span>
                                                            <h5
                                                                style={{
                                                                    border:
                                                                        "2px solid #0188cc",
                                                                    marginLeft:
                                                                        "15px",
                                                                    borderRadius:
                                                                        "12px",
                                                                    padding:
                                                                        "7px",
                                                                    textAlign:
                                                                        "center",
                                                                    width:
                                                                        "400px",
                                                                }}
                                                            >
                                                                <b>Year:</b>{" "}
                                                                <span className="subHeading">
                                                                    {e.doc_year}
                                                                </span>
                                                            </h5>
                                                        </span>
                                                        <span>
                                                            <h5
                                                                style={{
                                                                    border:
                                                                        "2px solid #0188cc",
                                                                    marginLeft:
                                                                        "15px",
                                                                    borderRadius:
                                                                        "12px",
                                                                    padding:
                                                                        "7px",
                                                                    textAlign:
                                                                        "center",
                                                                    width:
                                                                        "400px",
                                                                }}
                                                            >
                                                                <b>Month:</b>{" "}
                                                                <span className="subHeading">
                                                                    {
                                                                        e.doc_month
                                                                    }
                                                                </span>
                                                            </h5>
                                                        </span>
                                                        <span>
                                                            <IconButton
                                                                style={{
                                                                    color:
                                                                        "red",
                                                                    paddingBottom:
                                                                        "10px",
                                                                    float:
                                                                        "right",
                                                                }}
                                                                onClick={() => {
                                                                    this.props.deleteDownload(
                                                                        e.doc_id
                                                                    );
                                                                }}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </span>
                                                    </div>
                                                    <div className="clear"></div>
                                                </div>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
            </Grid>
        );
    }
}
export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const {
                selectReportTypes,
                selectMonth,
                selectToMonth,
                selectYear,
                selectReportType,
                selectReportsForExcel,
                selectReportKeys,
                selectDocuments,
            } = selectors;
            return {
                reportTypes: selectReportTypes(store),
                month: selectMonth(store),
                toMonth: selectToMonth(store),
                year: selectYear(store),
                reportType: selectReportType(store),
                selectedReports: selectReportsForExcel(store),
                reportKeys: selectReportKeys(store),
                downloads: selectDocuments(store),
            };
        },
        {
            getReports,
            getReportKeys,
            getReportTypes,
            setMonth,
            setToMonth,
            setYear,
            setReportType,
            getJobPackReports,
            getExcelDoc,
            getDownloads,
            setNewDownload,
            deleteDownload,
            getVehicleAlertReport,
        }
    )(BuildExcelDoc)
);
